var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-header"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"updated-last"},[_c('span',[_vm._v("Última Atualização:")]),_vm._v(" "+_vm._s(_vm.updatedAt))])])}
var staticRenderFns = []

export { render, staticRenderFns }